// extracted by mini-css-extract-plugin
export default {"imageWrapper":"styles_imageWrapper__dKGWi","newCommentEditor":"styles_newCommentEditor__gN1wv"};